import styled, { css } from 'styled-components';
import indents from '../../constants/js/indents.js';
import border from '../../constants/js/border.js';
import { buttonSizes } from './constant';
import { disableEvents, transitionCssMixin } from '../../mixins/custom';
import { textWeightStyles } from '../../mixins/text/textSizeWeight';
import { textOverflowEllipsis } from '../../mixins/text/textOverflowEllipsis';
import { buildSkin } from './Button.skins';
export const StyledIcon = styled.span.withConfig({
  componentId: "Button__sc-16w8pak-0"
})(["display:flex;align-items:center;justify-content:center;"]);
export const StyledLoader = styled.div.withConfig({
  componentId: "Button__sc-16w8pak-1"
})(["display:flex;position:absolute;"]);
export const StyledButton = styled.div.withConfig({
  componentId: "Button__sc-16w8pak-2"
})(["box-sizing:border-box;display:inline-flex;align-items:center;justify-content:", ";border-radius:", ";outline:0;cursor:pointer;user-select:none;border:1px solid transparent;", " ", " touch-action:manipulation;-webkit-tap-highlight-color:transparent;max-width:fill-available;", " ", " ", " ", " ", " ", ""], ({
  isSpaceBetweenIcon
}) => isSpaceBetweenIcon ? 'space-between' : 'center', border.borderRadius, transitionCssMixin('all'), textWeightStyles('regular'), ({
  size
}) => size && buttonSizes[size], ({
  isFullWidth
}) => isFullWidth && css(["width:100%;"]), ({
  skin,
  theme
}) => {
  var _a;

  return skin && buildSkin((_a = theme.Button) === null || _a === void 0 ? void 0 : _a.skin[skin]);
}, ({
  isDisabled
}) => isDisabled && `
			opacity: 0.56;
			${disableEvents}
		`, ({
  leftIcon,
  rightIcon
}) => (leftIcon || rightIcon) && css(["& > * + *{margin-left:", ";}& > div{margin-left:0;}"], indents.indentXXS), ({
  isLoading
}) => isLoading && css(["position:relative;color:transparent;", ""], disableEvents));
export const StyledText = styled.span.withConfig({
  componentId: "Button__sc-16w8pak-3"
})(["", ""], textOverflowEllipsis);